import { connect } from 'react-redux';
import { searchHotels, selectHotel, favoriteHotel, editGroupEvent, selectEvent, selectTour, newGroup,
  removeGroup,
  dispatchRemoveMemberFromGroup,
  editGroup,
  addMember,
  editMemberModal,
  saveRoomPreferences,
  addBidDetail,
  addMultipleBidDetail,
  requestquestions,
  requestTourquestions,
  AddedQuestions,
  createQuestions,
  createQuestionsmapping,
  removeQuestion,
  removeAddedQuestion,
  addBulkMultipleBidDetail,
  saveCityNotes,
  requestBidsets,
  DeleteEventNotes
 } from '../modules/tour';

import GroupsHotelPicker from './GroupsHotelPicker';

const mapDispatchToProps = {
  searchHotels,
  selectHotel,
  favoriteHotel,
  editGroupEvent,
  selectEvent,
  selectTour,
  dispatchRemoveMemberFromGroup,
  // importRoster,
  // importRoute,
  newGroup,
  removeGroup,
  editGroup,
  addMember,
  editMemberModal,
  saveRoomPreferences,
  addBidDetail,
  addMultipleBidDetail,
  requestquestions,
  requestTourquestions,
  AddedQuestions,
  createQuestions,
  createQuestionsmapping,
  removeQuestion,
  removeAddedQuestion,
  addBulkMultipleBidDetail,
  saveCityNotes,
  requestBidsets,
  DeleteEventNotes
};

const mapStateToProps = state => ({
  hotels: state.tours.hotels,
  fetchingHotels: state.tours.fetchingHotels,
  tours: state.tours.tours,
  selectedTour: state.tours.selectedTour,
  questions: state.tours.selectedQuestion,
  addQuestion: state.tours.additionalQuestion,
  addedQuestion: state.tours.addQuestion,
  checkBoxQuestion: state.tours.addedQuest,
});
const GroupsHotelPickerContainer = connect(mapStateToProps, mapDispatchToProps)(GroupsHotelPicker);
export default GroupsHotelPickerContainer;



// WEBPACK FOOTER //
// src/routes/tours/components/GroupsHotelPickerContainer.js